<div class="page">
  <header class="page-header">
    <h1 class="page-title">My Ideas</h1>
    <p class="page-subtitle">Track the status of your submitted ideas</p>
  </header>

  <div *ngIf="errorMessage" class="error-banner" role="alert">{{ errorMessage }}</div>
  <div *ngIf="loading" class="loading-state">
    <app-loader label="Loading your ideas"></app-loader>
  </div>

  <div *ngIf="!loading && !errorMessage">
    <div class="metrics-row" *ngIf="ideas.length > 0">
      <div class="metric-card">
        <span class="metric-value">{{ totalCount }}</span>
        <span class="metric-label">Total Ideas</span>
      </div>
      <div class="metric-card">
        <span class="metric-value">{{ inProgressCount }}</span>
        <span class="metric-label">In Progress</span>
      </div>
      <div class="metric-card">
        <span class="metric-value">{{ deliveredCount }}</span>
        <span class="metric-label">Delivered</span>
      </div>
      <div class="metric-card">
        <span class="metric-value metric-value-blue">{{ pointsEarned }}</span>
        <span class="metric-label">Points Earned</span>
      </div>
    </div>

    <div class="status-tabs" *ngIf="ideas.length > 0">
      <button
        *ngFor="let tab of statusTabs"
        type="button"
        class="status-tab"
        [class.active]="statusFilter === tab.value"
        (click)="setStatusFilter(tab.value)"
      >
        {{ tab.label }}{{ tab.value === 'all' ? ' (' + ideas.length + ')' : '' }}
      </button>
    </div>

    <div *ngIf="ideas.length === 0" class="empty-state">
      <p>You haven't submitted any ideas yet.</p>
      <p class="empty-hint">Share your ideas with the team and get feedback.</p>
      <a routerLink="/submit-idea" class="btn-primary">Submit Idea</a>
    </div>

    <div class="ideas-list" *ngIf="ideas.length > 0">
      <article *ngFor="let idea of filteredIdeas" class="idea-card">
        <div class="idea-card-inner">
          <div class="idea-card-content" [routerLink]="ideaRoute(idea)" [queryParams]="ideaQueryParams(idea)">
            <h3 class="idea-title">{{ idea.title }}</h3>
            <p *ngIf="idea.description" class="idea-description">{{ idea.description }}</p>
            <div class="idea-tags">
              <span class="tag" [ngClass]="getStatusClass(idea.status)">{{ getStatusLabel(idea.status) }}</span>
              <span class="tag tag-category">{{ idea.category.name }}</span>
              <span *ngIf="idea.challengeTitle" class="tag tag-challenge">{{ idea.challengeTitle }}</span>
            </div>
            <div class="idea-meta-row">
              <span class="idea-meta">Created {{ idea.createdAtUtc ? formatDate(idea.createdAtUtc) : '' }}</span>
              <div class="idea-engagement">
                <span class="engagement-item"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg> {{ getUpvoteCount(idea) }}</span>
                <span class="engagement-item"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/></svg> {{ getCommentCount(idea) }}</span>
              </div>
            </div>
          </div>
          <a [routerLink]="ideaRoute(idea)" [queryParams]="ideaQueryParams(idea)" class="btn-view">
            <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
            View
          </a>
        </div>
      </article>
    </div>

    <div *ngIf="!loading && ideas.length > 0 && filteredIdeas.length === 0" class="empty-filter-state">
      <p>No ideas match the selected filter.</p>
    </div>

    <div *ngIf="!loading && totalCount > pageSize" class="pagination">
      <button type="button" class="btn-secondary" [disabled]="page <= 1" (click)="previousPage()">Previous</button>
      <span class="page-info">Page {{ page }} of {{ totalPages }}</span>
      <button type="button" class="btn-secondary" [disabled]="page * pageSize >= totalCount" (click)="nextPage()">Next</button>
    </div>
  </div>
</div>
